module.exports = __webpack_public_path__ + "img/3.7179a396.jpg";